// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vDPf","disabled":"styles_disabled__1xYux"};